import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCf2: [],
		cf2: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {},
	mutations: {
		set(state, cf2) {
			state.cf2 = cf2
			if (cf2) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cf2 = null
		},
		setParamsDataTable(state, payload) {
			state.lstCf2 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		}
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		async find(store, cf2cep) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Address/ZipCode/Find/${cf2cep}`)
				.then(response => {
					let cf2 = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cf2)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			store.state.loading = false
		},
		save(store) {
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.post("/Address/ZipCode/Insert", store.state.cf2)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/codigos-cep")
					store.state.cf2 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.put("/Address/ZipCode/Update", store.state.cf2)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/codigos-cep")
					store.state.cf2 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			let cep =  new String(store.state.cf2.cf2cep).trim().replace(/[^\d]/g, "")
			await this._vm.$axios
				.delete(`/Address/ZipCode/Delete/${cep}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/codigos-cep")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get("/Address/ZipCode/FindList")
				.then(response => {
					let lstCf2 = Utils.ValidateAxiosResponse(response.data)
					store.state.lstCf2 = lstCf2
					store.state.hasNext = lstCf2.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstCf2 = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Address/ZipCode/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCf2 = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
			return payload
		},
		async findZipCode(store, postalCode) {
			let lxe = store.rootState.lxe.lxe
			if (!lxe || !lxe.lxeapicep) {
				return { erro: "Parâmetro de serviço de consulta CEP não cadastrado" }
			}

			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Buscando CEP...", indeterminate: true },
				{ root: true }
			)
			return await this._vm.$axios
				.get(`${lxe.lxeapicep}/${postalCode}/json`, { 
					headers: { "Content-Type": "application/json" },
					timeout: 10000
				})
				.then(response => {
					let addressModel = response.data
					store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
					return addressModel
				})
				.catch(error => {
					store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
					
					let mensagem = "Erro ao consultar CEP"
					if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
						mensagem = "Tempo limite excedido. Serviço de CEP indisponível"
					} else if (error.code === "ERR_NETWORK" || !navigator.onLine) {
						mensagem = "Sem conexão com o serviço de CEP"
					} else if (error.response?.status >= 500) {
						mensagem = "Serviço de CEP temporariamente indisponível"
					}
					return { erro: error.message }
				})
		}
	}
}
